import { Box, Popover, PopoverTrigger, Progress } from "@chakra-ui/react";
import type { SubmitProgressMutation } from "@src/__generated__/graphql";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { PercentModel } from "@src/utils/models";
import { observer, useLocalObservable } from "mobx-react-lite";
import { OurWorkProgressBarPopoverContent } from "./components/our-work-progress-bar-popover-content";
import { OurWorkProgressBarStore } from "./store";

export type OurWorkProgressBarProps = {
  /** number value must be denominated */
  progress: PercentModel | number;
  onSubmitProgress?: (data: SubmitProgressMutation["submitProgress"]) => void;
  budgetItemId?: string;
  selectedPeriodId?: string;
  editable?: boolean;
};

export const OurWorkProgressBar = observer(function OurWorkProgressBar({
  progress,
  onSubmitProgress,
  budgetItemId,
  selectedPeriodId,
  editable,
}: OurWorkProgressBarProps) {
  const store = useLocalObservable(
    () =>
      new OurWorkProgressBarStore({
        budgetItemId,
        onSubmitProgress,
        selectedPeriodId,
      }),
  );

  const progressNumber =
    progress instanceof PercentModel
      ? progress.value
      : PercentModel.fromRawValue(progress).value;

  return (
    <WrapComponent
      if={store.disclosure.isOpen}
      with={(children) => (
        <Popover
          isLazy
          isOpen
          onClose={store.disclosure.onClose}
          trigger="click"
        >
          <PopoverTrigger>{children}</PopoverTrigger>
          <OurWorkProgressBarPopoverContent store={store} />
        </Popover>
      )}
    >
      <Box
        cursor={editable ? "pointer" : undefined}
        onClick={(e) => {
          e.stopPropagation();
          store.toggle(editable);
        }}
      >
        <Progress colorScheme="linkedin" rounded="xl" value={progressNumber} />
      </Box>
    </WrapComponent>
  );
});
